import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import React, {useEffect, useState} from "react";
import {Auth} from "@aws-amplify/auth";
import { useHistory } from "react-router-dom";
import ApiService from "../../ApiService";
import PageTitle from "../Common/PageTitle/PageTitle";
import {
    format_yyyy_mm_dd_to_DATETIME_MED, formatUSMobileNum,
    getAgeInYrsMonthsDisplay,
    getIsoToMediumFormatDatetime, getRegion
} from '../../util/common.js';
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import InputGroup from "react-bootstrap/InputGroup";
import FormControl from "react-bootstrap/FormControl";
import removeClass from "../../util/RemoveCSS";
import MaterialTable from 'material-table';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { NoteAdd, AssignmentTurnedIn, PostAdd, PersonAdd, NotInterested } from "@material-ui/icons";
import { makeStyles } from '@material-ui/core/styles';
import MuiAlert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import {validClinicianLicenseStates} from '../../util/licence-util';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
}));

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const UserRequest = () => {
    const classes = useStyles();

    const [assignedTestRequests, setAssignedTestRequests] = useState([]);
    const [clinicianId, setClinicianId] = useState(null);
    //const [clinicianState, setClinicianState] = useState(null);
    const [clinicianValidStates, setClinicianValidStates] = useState([]);
    const [customerId, setCustomerId] = useState(null);
    const [show, setShow] = useState(null);
    const [showAddressDetails, setShowAddressDetails] = useState(null);
    const [noteKitId, setNoteKitId] = useState(null);
    const [internalNoteText, setInternalNoteText] = useState(null);
    const [externalNoteText, setExternalNoteText] = useState(null);
    const [isReadOnly, setIsReadOnly] = useState(false);
    const [patientName, setPatientName] = useState(null);
    const [patientAddress, setPatientAddress] = useState(null);
    const [city, setCity] = useState(null);
    const [state, setState] = useState(null);
    const [zip, setZip] = useState(null);
    const [patientEmail, setPatientEmail] = useState(null);
    const [phoneNumber, setPhoneNumber] = useState(null);
    const [backdropOpen, setBackdropOpen] = useState(false);
    const [snackOpen, setSnackOpen] = useState(false);
    const [snackText, setSnackText] = useState('');
    const [snackSeverity, setSnackSeverity] = useState('');

    const handleSnackOpen = (text, severity) => {
        setSnackSeverity(severity)
        setSnackText(text)
        setSnackOpen(true);
    };
    
    const handleSnackClose = () => {
        setSnackOpen(false);
    };

    let history = useHistory();

    removeClass();

    useEffect(() => {
        Auth.currentAuthenticatedUser()
            .then(() => {
                Auth.currentSession().then(sess => {
                    const tokenId = sess.getIdToken().getJwtToken();
                    setClinicianId(sess.getIdToken().payload.sub)
                    if (tokenId) {
                        async function getAssignedLabRequests() {
                            try {
                                const getAssignedLabRequests = await ApiService.getAssignedLabRequests();
                                var lastURLSegment = history.location.pathname.substr(history.location.pathname.lastIndexOf('/') + 1);
                                const result = getAssignedLabRequests.data.filter(data => data.kitId === lastURLSegment);
                                if(result !== null) {
                                    setAssignedTestRequests(result);
                                }
                            } catch(ex) {
                                console.error(ex);
                            }
                        }
                        getAssignedLabRequests().then(r => r);
                        validClinicianLicenseStates().then(states => setClinicianValidStates(states));
                    }
                    setCustomerId(tokenId);
                });
            }).catch(err => {
            console.error(err);
            handleSnackOpen(`failed loading, ${err?.message}`, 'error');
        });
    }, []);

    function approve(kitId) {
        setBackdropOpen(true);
        async function putApproveLabRequest() {
            try {
                // eslint-disable-next-line no-unused-vars
                const putApproveLabRequest = await ApiService.putApproveLabRequest({"kitId": kitId});
                setBackdropOpen(false);
                handleSnackOpen('Approved!', "success")
            } catch(err) {
                console.error(err);
                setBackdropOpen(false);
                handleSnackOpen(err.message, "error")
            }
        }
        putApproveLabRequest().then(r => r);
    }

    function rejectNotes(internalNotes, externalNotes) {
        setBackdropOpen(true);
        async function putRejectLabRequest() {
            try {
                // eslint-disable-next-line no-unused-vars
                const putRejectLabRequest = await ApiService.putRejectLabRequest({"kitId": noteKitId, "externalNote": externalNotes, "internalNote": internalNotes});
                setBackdropOpen(false);
                handleSnackOpen('Reject Note Added', "success")
            } catch(err) {
                console.error(err);
                setBackdropOpen(false);
                handleSnackOpen(err.message, "error")
            }
        }
        putRejectLabRequest().then(r => r);
    }

    const handleClose = () => {
        setShow(false);
    }

    const handleShow = (kitId, internalNote, externalNote, status) => {
        setNoteKitId(kitId);
        setInternalNoteText(internalNote)
        setExternalNoteText(externalNote);
        'REJECTED_BY_CLINICIAN' === status ? setIsReadOnly(true) : setIsReadOnly(false);
        setShow(true);
    }

    const handleAddressessClose = () => {
        setShowAddressDetails(false);
    }

    const handleAddresseeShow = (name, street_address, locality, region, postal_code, email, phoneNumber) => {
        setPatientName(name);
        setPatientAddress(street_address);
        setCity(locality);
        setState(region);
        setZip(postal_code);
        setPatientEmail(email);
        setPhoneNumber(phoneNumber);
        setShowAddressDetails(true);
    }

    function processNotes(event) {
        handleClose();
        event.preventDefault();
        const externalNotesNumels = document.getElementsByName("externalNotesText").length;
        const externalNotes = document.getElementsByName("externalNotesText")[externalNotesNumels - 1].value;
        const internalNotesNumels = document.getElementsByName("internalNotesText").length;
        const internalNotes = document.getElementsByName("internalNotesText")[internalNotesNumels - 1].value;
        rejectNotes(internalNotes, externalNotes);
    }

    if (assignedTestRequests) {
        return (
            <Container fluid>
                <PageTitle titleName={"Case details"} />
                <Container fluid={"lg"}>
                <Row>
                <MaterialTable
                        columns={[
                            { 
                                title: 'Patient Name',
                                field: 'user.name',
                                render: rowData => (
                                    <a href="#"
                                    onClick={() => handleAddresseeShow(rowData.user?.name, rowData.user?.address?.street_address, rowData.user?.address?.locality, getRegion(rowData.user), rowData.user?.address?.postal_code, rowData.user?.email, rowData.user?.phoneNumber)}>{rowData.user?.name}</a>
                                ),
                                cellStyle: {
                                    width: 150,
                                    minWidth: 150
                                },
                                    headerStyle: {
                                    width: 150,
                                    minWidth: 150
                                }, 
                            },
                            {
                                title: 'Preferred Name',
                                field: 'user.preferredName',
                                cellStyle: {
                                    width: 150,
                                    minWidth: 150
                                },
                                headerStyle: {
                                    width: 150,
                                    minWidth: 150
                                },
                            },
                            { 
                                title: 'Patient Email',
                                field: 'user.email',
                                cellStyle: {
                                    width: 150,
                                    minWidth: 150
                                },
                                    headerStyle: {
                                    width: 150,
                                    minWidth: 150
                                }, 
                            },
                            { 
                                title: 'Kit ID',
                                field: 'kitId',
                                cellStyle: {
                                    width: 150,
                                    minWidth: 150
                                },
                                    headerStyle: {
                                    width: 150,
                                    minWidth: 150
                                }, 
                            },
                            {
                                title: 'Status',
                                field: 'status'
                            },
                            { 
                                title: 'Clinician',
                                field: 'clinician.firstName',
                                render: rowData => {
                                    if(rowData.clinician !== null) {
                                        return <span>{rowData.clinician.firstName} {rowData.clinician.lastName}</span>
                                    } else {
                                        return <span>needs clinician</span>
                                    }
                                },
                                cellStyle: {
                                    width: 150,
                                    minWidth: 150
                                },
                                    headerStyle: {
                                    width: 150,
                                    minWidth: 150
                                }, 
                            },
                            { 
                                title: 'Date of Registration',
                                field: 'createDateTime',
                                render: rowData => (
                                    getIsoToMediumFormatDatetime(rowData.createDateTime)
                                ),
                                cellStyle: {
                                    width: 150,
                                    minWidth: 150
                                },
                                    headerStyle: {
                                    width: 150,
                                    minWidth: 150
                                },
                            },
                            { title: 'Patient Sex at Birth', field: 'user.genderAtBirth' },
                            { 
                                title: 'Patient DOB',
                                field: 'user.dob',
                                render: rowData => (
                                    <>
                                        <div>{format_yyyy_mm_dd_to_DATETIME_MED(rowData.user?.dob)}</div>
                                        <div>{getAgeInYrsMonthsDisplay(rowData.user?.dob)}</div>
                                    </>
                                ),
                                cellStyle: {
                                    width: 200,
                                    minWidth: 200
                                },
                                headerStyle: {
                                    width: 200,
                                    minWidth: 200
                                },
                            },
                            { 
                                title: 'Phone Number',
                                field: 'phoneNumber',
                                render: rowData  => formatUSMobileNum(rowData.user?.phoneNumber),
                                cellStyle: {
                                    width: 170,
                                    minWidth: 170
                                },
                                    headerStyle: {
                                    width: 170,
                                    minWidth: 170
                                },
                                filtering: false
                            },
                            { title: 'Allergies', field: 'user.allergies', filtering: false },
                            { title: 'Current Medications', field: 'medications', filtering: false },
                            { title: 'Current Symptoms', field: 'symptoms', filtering: false },
                            { title: 'Patient State', field: 'user.address.region' },
                            { title: 'Product Name', field: 'productName' },
                        ]}
                        actions={[ 
                            (rowData) => {
                                if(clinicianValidStates && clinicianValidStates.includes(getRegion(rowData.user)) && (rowData.clinician === null || clinicianId === rowData.clinician.userId)) {
                                    if (rowData.status !== 'REPORT_READY' && rowData.status !== 'REJECTED_BY_CLINICIAN' && rowData.status !== 'COMPLETE') {
                                        if (rowData.clinician === null) {
                                            return
                                        } else {
                                            if (rowData.status === 'REGISTERED') {
                                                return {
                                                    icon: () => <div id={'action-' + rowData.kitId}><AssignmentTurnedIn id={"approve-" + rowData.kitId} name={"approve-" + rowData.kitId} /></div>,
                                                    tooltip: 'Approve',
                                                    onClick: () => approve(rowData.kitId)
                                                }
                                            } else {
                                                return {
                                                    icon: () => <div id={'action-' + rowData.kitId}><NotInterested /></div>,
                                                    tooltip: 'No action needed',
                                                    disabled: true
                                                }
                                            }
                                        }
                                    } else if (rowData.status === 'REJECTED_BY_CLINICIAN') {
                                        return {
                                            icon: () => <NoteAdd id={"reject-" + rowData.kitId} name={"reject-" + rowData.kitId} />,
                                            tooltip: 'View Reject Notes for Patient',
                                            onClick: () => handleShow(rowData.kitId, rowData.internalNote, rowData.externalNote, rowData.status)
                                        }
                                    } else {
                                        return {
                                            icon: () => <div id={'action-' + rowData.kitId}><NotInterested /></div>,
                                            tooltip: 'No action needed',
                                            disabled: true
                                        }
                                    }
                                } else {
                                    if (rowData.status !== 'REPORT_READY' && rowData.status !== 'REJECTED_BY_CLINICIAN' && rowData.status !== 'COMPLETE') {
                                        if (rowData.clinician === null) {
                                            return {
                                                icon: () => <PersonAdd className="gray-button" id={"assign-" + rowData.kitId}/>,
                                                tooltip: 'license ineligible',
                                                disabled: true,
                                            }
                                        } else {
                                            if (rowData.status === 'REGISTERED') {
                                                return {
                                                    icon: () => <div id={'action-' + rowData.kitId}><AssignmentTurnedIn className="gray-button" id={"approve-" + rowData.kitId} name={"approve-" + rowData.kitId} /></div>,
                                                    tooltip: 'license ineligible',
                                                    disabled: true,
                                                }
                                            } else if (process.env.REACT_APP_ENV === 'sandbox') {
                                                return {
                                                    icon: () => <div id={'action-' + rowData.kitId}><NoteAdd className="gray-button" id={"test-" + rowData.kitId} name={"test-" + rowData.kitId} /></div>,
                                                    tooltip: 'license ineligible',
                                                    disabled: true,
                                                }
                                            } else {
                                                return {
                                                    icon: () => <div id={'action-' + rowData.kitId}><NotInterested className="gray-button" /></div>,
                                                    tooltip: 'license ineligible',
                                                    disabled: true
                                                }
                                            }
                                        }
                                    } else if (rowData.status === 'REJECTED_BY_CLINICIAN') {
                                        return {
                                            icon: () => <NoteAdd className="gray-button" id={"reject-" + rowData.kitId} name={"reject-" + rowData.kitId} />,
                                            tooltip: 'license ineligible',
                                            disabled: true,
                                            onClick: () => handleShow(rowData.kitId, rowData.internalNote, rowData.externalNote, rowData.status)
                                        }
                                    } else {
                                        return {
                                            icon: () => <div id={'action-' + rowData.kitId}><NotInterested className="gray-button" /></div>,
                                            tooltip: 'license ineligible',
                                            disabled: true
                                        }
                                    }
                                }
                            },
                            (rowData) => {
                                if(clinicianValidStates && clinicianValidStates.includes(getRegion(rowData.user)) && (rowData.clinician === null || clinicianId === rowData.clinician.userId)) {
                                    if (rowData.status !== 'REPORT_READY' && rowData.status !== 'REJECTED_BY_CLINICIAN' && rowData.status !== 'COMPLETE') {
                                        if (rowData.clinician === null) {
                                            return 
                                        } else {
                                            if (rowData.status === 'REGISTERED') {
                                                return (
                                                    {
                                                        icon: () => <div id={'action-' + rowData.kitId}><PostAdd id={"reject-" + rowData.kitId} name={"reject-" + rowData.kitId}  /></div>,
                                                        tooltip: 'Add Reject Notes for Patient',
                                                        onClick: () => handleShow(rowData.kitId, rowData.internalNote, rowData.externalNote, rowData.status)
                                                    }
                                                )
                                            } else {
                                                return
                                            }
                                        }
                                    } else {
                                        return 
                                    }
                                } else {
                                    if (rowData.status !== 'REPORT_READY' && rowData.status !== 'REJECTED_BY_CLINICIAN' && rowData.status !== 'COMPLETE') {
                                        if (rowData.clinician === null) {
                                            return 
                                        } else {
                                            if (rowData.status === 'REGISTERED') {
                                                return (
                                                    {
                                                        icon: () => <div id={'action-' + rowData.kitId}><PostAdd className="gray-button" id={"reject-" + rowData.kitId} name={"reject-" + rowData.kitId}  /></div>,
                                                        tooltip: 'license ineligible',
                                                        disabled: true
                                                    }
                                                )
                                            } else {
                                                return
                                            }
                                        }
                                    } else {
                                        return 
                                    }
                                }
                            }
                        ]}
                        data={assignedTestRequests} 
                        options={{
                            filtering: false,
                            exportButton: true,
                            search: true,
                            pageSize: 50,
                            pageSizeOptions : [50, 100, 200],
                            emptyRowsWhenPaging: false,
                            actionsColumnIndex: -1,
                            draggable: false,
                            showTitle: false
                        }}
                    />

                    <Modal show={show} onHide={() => handleClose()} backdrop={'static'}>
                        <Modal.Header closeButton>
                            <Modal.Title>Reject Notes</Modal.Title>
                        </Modal.Header>
                        <Form onSubmit={processNotes}>
                            <span>Internal Notes</span>
                            <InputGroup>
                                <FormControl name={"internalNotesText"} as="textarea" rows="10"
                                             cols="120"
                                             aria-label="With textarea" disabled={isReadOnly}>
                                    {internalNoteText}
                                </FormControl>
                            </InputGroup>
                            <span>Reject Notes for Patient</span>
                            <InputGroup>
                                <FormControl name={"externalNotesText"} as="textarea" rows="10"
                                             cols="120"
                                             aria-label="With textarea" disabled={isReadOnly}>
                                    {externalNoteText}
                                </FormControl>
                            </InputGroup>
                        </Form>

                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}>
                                Close
                            </Button>
                            {
                                isReadOnly ? "" :
                                    <Button variant="primary" onClick={processNotes} type={'submit'}>
                                        Save Changes
                                    </Button>
                            }
                        </Modal.Footer>
                    </Modal>
                    <Modal show={showAddressDetails} onHide={() => handleAddressessClose()} backdrop={'static'}>
                        <Modal.Header closeButton>
                            <Modal.Title>Patient Details</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {patientName}<br/>
                            {patientAddress}<br/>
                            {city}, {state} {zip}<br/>
                            {patientEmail}<br/>
                            {phoneNumber}
                        </Modal.Body>
                    </Modal>
                </Row>
                <Backdrop className={classes.backdrop} open={backdropOpen}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Snackbar open={snackOpen} autoHideDuration={6000} onClose={handleSnackClose} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
                    <Alert onClose={handleSnackClose} severity={snackSeverity}>
                        {snackText}
                    </Alert>
                </Snackbar>
                </Container>
            </Container>
        )
    } else {
        return (
            <Container fluid>
                <Row>
                    <div>Please wait. Loading...</div>
                </Row>
            </Container>
        )
    }
}

export default UserRequest